import SearchScreen from './SearchScreen';

/**
 * Started building the vertical tile for search results screen but its not
 * complete so hardcoded whats existing.
 *
 * To finish this will need design for the additional info that is brought up. e.g. additional brand info.
 */
export default SearchScreen;
